var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKillSwitch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.19 14H19.81C16.17 14 14 16.17 14 19.81V28.18C14 31.83 16.17 34 19.81 34H28.18C31.82 34 33.99 31.83 33.99 28.19V19.81C34 16.17 31.83 14 28.19 14ZM29.85 26.1C29.81 26.19 29.76 26.27 29.69 26.34L26.65 29.38C26.5 29.53 26.31 29.6 26.12 29.6C25.93 29.6 25.74 29.53 25.59 29.38C25.3 29.09 25.3 28.61 25.59 28.32L27.35 26.56H18.85C18.44 26.56 18.1 26.22 18.1 25.81C18.1 25.4 18.44 25.06 18.85 25.06H29.16C29.26 25.06 29.35 25.08 29.45 25.12C29.63 25.2 29.78 25.34 29.86 25.53C29.92 25.71 29.92 25.92 29.85 26.1ZM29.15 22.93H18.85C18.75 22.93 18.66 22.91 18.56 22.87C18.38 22.79 18.23 22.65 18.15 22.46C18.07 22.28 18.07 22.07 18.15 21.89C18.19 21.8 18.24 21.72 18.31 21.65L21.35 18.61C21.64 18.32 22.12 18.32 22.41 18.61C22.7 18.9 22.7 19.38 22.41 19.67L20.66 21.43H29.16C29.57 21.43 29.91 21.77 29.91 22.18C29.91 22.59 29.57 22.93 29.15 22.93Z",
    fill: "#34D399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2166",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2166",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKillSwitch);
export default __webpack_public_path__ + "static/media/icon-kill-switch.a3ce9ffbc28e40c73013a8b43a86f0db.svg";
export { ForwardRef as ReactComponent };